<template>
  <div>
    <div class="mt-4 mb-4 flex justify-between items-center">
      <div class="">
        <span>Ativar Modal de Aviso do Sistema?</span>
        <vs-switch
          color="success"
          v-model="systemNotice.active"
          style="width: 60px"
          data-testId="gallery-switch"
        >
          <span slot="on">Sim</span>
          <span slot="off">Não</span>
        </vs-switch>
      </div>

      <vs-button @click.stop.prevent="openViewModal">
        Pré-visualizar
      </vs-button>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <span>Título do modal do aviso do sistema</span>
        <vs-input
          class="w-full"
          v-model="systemNotice.title"
          val-icon-danger="clear"
        />
      </div>
    </div>

    <quillEditor
      v-model="systemNotice.html"
      ref="quillEditor"
      :options="editorOption"
      style="height: fit-content"
    />

    <Modal
      id="popup-system-notice"
      class="holamundo"
      :active.sync="popupActive"
      :title="title"
      @close="closeViewModal"
    >
      <div class="flex flex-col">
        <div v-html="systemNotice.html"></div>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from '../../components/Modal.vue';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor } from 'vue-quill-editor';

import Quill from 'quill';
import { ImageExtend, QuillWatch } from 'quill-image-extend-module';
import notify from '../../utils/notify';

Quill.register('modules/ImageExtend', ImageExtend);

export default {
  name: 'FormSystemNotice',
  components: {
    quillEditor,
    Modal,
  },
  props: {
    systemNoticeProp: {
      type: String,
      default: () => `{}`,
    },
  },
  data() {
    return {
      systemNotice: {
        active: this.parseSystemNotice().active,
        title: this.parseSystemNotice().title,
        html: this.parseSystemNotice().html,
      },
      popupActive: false,
      quillId: null,
      editorOption: {
        theme: 'snow',
        placeholder: 'Pressione Enter para adicionar conteúdo',
        modules: {
          toolbar: {
            container: [
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              ['bold', 'italic', 'underline'],
              [{ color: [] }, { background: [] }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ align: [] }],
              ['link', 'image'],
              ['clean'],
            ],
            handlers: {
              image: function () {
                this.quillId = this.quill.id;
                return QuillWatch.emit(this.quill.id);
              },
            },
          },
          ImageExtend: {
            name: 'file',
            action: `${process.env.VUE_APP_API_VIDA_URL}/files/custom-upload?path=avisosSistema`,
            size: 5,
            accept: 'image/png, image/jpeg, image/gif, image/svg+xml',
            response: (res) => {
              return res.url;
            },
            headers: (xhr) => {
              xhr.setRequestHeader(
                'Authorization',
                `Bearer ${localStorage.getItem('user-token')}`,
              );
            },
          },
        },
      },
    };
  },
  computed: {
    title() {
      return this.systemNotice.title;
    },
  },
  watch: {
    systemNotice: {
      handler() {
        this.emitUpdate();
      },
      deep: true,
    },
  },
  methods: {
    parseSystemNotice() {
      if (!this.systemNoticeProp) {
        return {
          active: false,
          title: null,
          html: null,
        };
      }

      const systemNotice = JSON.parse(this.systemNoticeProp);
      return {
        active: systemNotice.active || false,
        title: systemNotice.title || null,
        html: systemNotice.html || null,
      };
    },
    emitUpdate() {
      this.$emit('update', JSON.stringify(this.systemNotice));
    },
    openViewModal() {
      this.popupActive = true;
    },
    closeViewModal() {
      this.popupActive = false;
    },
    validate() {
      if (this.systemNotice.active && !this.systemNotice.title) {
        notify.notifyFail(this.$vs, 'O título do modal é obrigatório.');
        return false;
      }
      if (this.systemNotice.active && !this.systemNotice.html) {
        notify.notifyFail(this.$vs, 'O conteúdo do modal é obrigatório.');
        return false;
      }
      return true;
    },
  },
};
</script>
<style>
#popup-system-notice.con-vs-popup .vs-popup {
  width: fit-content !important;
  height: fit-content !important;
}

.popup-system-notice {
  overflow: visible;
}

.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}

.ql-align-center img {
  display: block;
  margin: 0 auto;
}

.ql-align-right img {
  display: block;
  margin-left: auto;
}

.ql-align-center iframe {
  display: block;
  margin: 0 auto;
}

.ql-align-right iframe {
  display: block;
  margin-left: auto;
}
</style>
